/* eslint-disable react/no-danger */
import classNames from 'classnames';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { CLICK_AMP_COLLECT } from '../../brands/default/constants';
import { MAIN_DEAL_FINE_PRINT_COMPONENT } from '../../brands/default/content/components/deal';
import { ADMIN_FEE_TERMS } from '../../brands/default/links';
import { isAdminFeeDeal } from '../../helpers/deals';
import ThemeContext from '../../providers/ThemeProvider';
import CollapsableSection from './shared-components/CollapsableSection';

const isPayPalCreditEnabled = JSON.parse(
  process.env.NEXT_PUBLIC_PAYPAL_CREDIT_ENABLED === 'true',
);

const displayPaypalTerms = (term) => {
  if (
    !term.includes('Paypal Credit') ||
    (term.includes('Paypal Credit') && isPayPalCreditEnabled)
  )
    return term;
  else return MAIN_DEAL_FINE_PRINT_COMPONENT.payPalPayLaterFinePrintText;
};

const MainDealFinePrint = ({ deal, className, collapsed, onToggle }) => {
  const theme = useContext(ThemeContext);

  if (!deal || !deal.terms || deal.terms.length === 0) {
    return null;
  }

  const closingDealInfo = () => {
    const closingDate = dayjs(deal.closingDate).format('DD.MM.YYYY');

    return `${MAIN_DEAL_FINE_PRINT_COMPONENT.dealWillBeAdvertised} ${closingDate}. ${MAIN_DEAL_FINE_PRINT_COMPONENT.priceMayChange}`;
  };

  const estimatedDeliveryDate = deal.estimatedDeliveryDate
    ? dayjs(deal.estimatedDeliveryDate).format('DD.MM.YYYY')
    : null;

  const showPayCredit = deal.price >= 190 && deal.price <= 2_000;

  const isAdminFee = isAdminFeeDeal(deal);

  return (
    <>
      <div className={classNames('terms', className)}>
        <CollapsableSection
          collapsed={collapsed}
          onToggle={onToggle}
          title={MAIN_DEAL_FINE_PRINT_COMPONENT.finePrintText}
        >
          <ul className="terms__list">
            {deal.terms.map((term, index) => {
              if (term.includes(CLICK_AMP_COLLECT)) return null;

              return (
                <li
                  className="terms__item"
                  dangerouslySetInnerHTML={{ __html: displayPaypalTerms(term) }}
                  key={index}
                />
              );
            })}
            {isAdminFee && (
              <li className="terms__item">
                <a
                  className="admin-fee-link"
                  href={ADMIN_FEE_TERMS}
                  rel="noreferrer"
                  target={'_blank'}
                >
                  {MAIN_DEAL_FINE_PRINT_COMPONENT.adminFeeTerm}
                </a>
              </li>
            )}
            {deal.closingDate && (
              <li className="terms__item">{closingDealInfo()}</li>
            )}
            {deal.display.preOrderDeal && estimatedDeliveryDate && (
              <li className="terms__item">
                {MAIN_DEAL_FINE_PRINT_COMPONENT.preOrderBuyAndRedeem(
                  estimatedDeliveryDate,
                )}
              </li>
            )}
          </ul>
        </CollapsableSection>
      </div>
      {showPayCredit && isPayPalCreditEnabled && (
        <div
          dangerouslySetInnerHTML={{
            __html:
              MAIN_DEAL_FINE_PRINT_COMPONENT.payPalCreditRepresentativeText,
          }}
        />
      )}
      <style jsx>{`
        .terms__list {
          list-style: none;
          padding-left: 0;
          column-count: 2;
          column-gap: 30px;
        }
        .terms__item {
          position: relative;
          break-inside: avoid;
          margin-left: 16px;
        }
        .terms__item:before {
          position: absolute;
          display: inline-block;
          content: '';
          height: 6px;
          width: 6px;
          background-color: ${theme.colors.primary};
          border-radius: 50%;
          top: 0.5em;
          left: -16px;
        }
        .admin-fee-link {
          color: ${theme.commoncolors.greycharcoal};
          text-decoration: underline;
          text-decoration-style: dashed;
        }
        :global(.terms a) {
          color: ${theme.colors.primary};
        }
        @media (max-width: ${theme.breakpoints.xlDown}) {
          .terms__list {
            column-count: 1;
            column-gap: 20px;
          }
        }
      `}</style>
    </>
  );
};

MainDealFinePrint.propTypes = {
  className: PropTypes.string,
  collapsed: PropTypes.bool,
  deal: PropTypes.object,
  onToggle: PropTypes.func,
};

MainDealFinePrint.defaultProps = {
  className: '',
  collapsed: false,
  deal: null,
  onToggle: () => false,
};

export default MainDealFinePrint;
